export default "__VITE_ASSET__8c969135__"